export const SAVED_VIEWS_ENTITY = 'contract';
